module.exports = __webpack_public_path__ + "img/s8-qb2.07b9821d.png";